import { AiChatHistory } from 'types';

export const getBrainstormTopicSuggestions = (): Partial<AiChatHistory>[] => {
  return [
    { name: 'Explain the concept of the Great Barrier Reef in detail' },
    { name: 'What are the latest higher education trends to improve teaching curricula for new generation?' },
  ];
};
